var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widget-map map", attrs: { id: "widgetMap" } },
    [
      _c(
        "div",
        { staticClass: "absolute bottom-2 right-2 z-1" },
        [
          _c("UiSwitch", {
            staticStyle: {
              width: "200px",
              "box-shadow": "var(--shadows-base)",
            },
            attrs: {
              labelYes: _vm.$t("plans.mapstyles.vecto"),
              labelNo: _vm.$t("plans.mapstyles.sat"),
            },
            model: {
              value: _vm.displayMapVecto,
              callback: function ($$v) {
                _vm.displayMapVecto = $$v
              },
              expression: "displayMapVecto",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasPrivacyOption
        ? _c("div", { staticClass: "geo-authorization" }, [
            _c("i", {
              staticClass: "fa fa-exclamation-circle",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("home.widgets.map.privacy_option_warning"))),
            ]),
          ])
        : !_vm.hasLocationVisibility
        ? _c("div", { staticClass: "geo-authorization" }, [
            _c("i", {
              staticClass: "fa fa-exclamation-circle",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("home.widgets.map.location_disabled_role"))),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }